// FormSwitch.tsx
import React from "react";
import { useController } from "react-hook-form";
import { Switch } from "@/components/atoms/Switch";
import { cn } from "@/utils/cn";
import { FormSwitchProps } from "./FormSwitch.types";

export const FormSwitch: React.FC<FormSwitchProps> = ({
    name,
    control,
    label,
    variant = "primary",
    inactiveVariant = "default",
    size = "md",
    disabled = false,
    className,
    onCheckedChange,
}) => {
    const {
        field: { value, onChange },
        fieldState: { error }
    } = useController({ name, control });

    return (
        <div>
            <Switch
                label={label}
                variant={variant}
                inactiveVariant={inactiveVariant}
                size={size}
                checked={!!value}
                onCheckedChange={(checked: boolean) => {
                    onChange(checked);
                    onCheckedChange && onCheckedChange(checked);
                }}
                disabled={disabled}
                className={cn(
                    error && "border-red-500 focus:ring-red-500",
                    className
                )}
            />
            {error && (
                <p className="text-red-600 text-sm mt-1" role="alert">
                    {error.message}
                </p>
            )}
        </div>
    );
};
